import React from 'react';
import ReactGA from 'react-ga';
import { Label, Container, Button, Message, Divider} from 'semantic-ui-react'
import Input from '../UI/Input/Input'
import * as actions from '../../actions/index';
import { connect } from 'react-redux'
import {Redirect} from 'react-router-dom'

class Login extends React.Component {
  
    componentDidMount() {
        ReactGA.ga('send', 'pageview', '/login');
    }

  state = {
        controls: {
            email: {
                elementtype: 'input',
                elementconfig: {
                    type: 'email',
                    placeholder: 'Mail Address'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false,
            },
            password: {
                elementtype: 'input',
                elementconfig: {
                    type: 'password',
                    placeholder: 'Password'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            }
        },
        formIsValid: false
  }
  
  checkValidity(value, rules){
      let isValid = true;

      const {required, minLength} = rules;

      if(required){
          isValid = value.trim() !== ''  && isValid;
      }
      if(minLength){
        isValid = value.length >= minLength && isValid;
    }
      return isValid;   
  }

  inputChangedHandler = (event, formElementId) => {
    const updatedControlsForm = {...this.state.controls};
    const updatedFormElement = {...updatedControlsForm[formElementId]};
    
    updatedFormElement.value = event.target.value;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,updatedFormElement.validation);
    updatedFormElement.touched = true;
    updatedControlsForm[formElementId] =updatedFormElement;


    let formIsValid = true;
    for (let inputIdentifiers in updatedControlsForm){
        formIsValid = updatedControlsForm[inputIdentifiers].valid && formIsValid
    }

    this.setState({controls: updatedControlsForm, formIsValid: formIsValid})
  }

  controlsHandler = (event) => {
      event.preventDefault();

      this.props.onAuth(this.state.controls.email.value, this.state.controls.password.value);
  }

  render ()
  {

    let errorMessage = null;

    if(this.props.error){
        errorMessage = (
            <Message negative>
                <Message.Header>Login Error</Message.Header>
                <p>{this.props.error.message}</p>
            </Message>
            
        )
    }

    const formElementsArray = [];
    for (let key in this.state.controls) {
        formElementsArray.push({
            id: key,
            config: this.state.controls[key]
        });
    }

    const form = formElementsArray.map(formElement => (
        <Input
            key={formElement.id}
            elementtype={formElement.config.elementtype}
            elementconfig={formElement.config.elementconfig}
            value={formElement.config.value}
            invalid={!formElement.config.valid}
            shouldvalidate={formElement.config.validation}
            touched={formElement.config.touched}
            changed={(event)=>this.inputChangedHandler(event, formElement.id)}
        />
    ))

    let authRedirect = null;
    if(this.props.isAuthenticated){
        authRedirect = <Redirect to="/events/list"/>
    }
   
    return <React.Fragment>
            <Container>
                <Divider hidden/>
                <Label style={{ backgroundColor: "#008000"}} horizontal  size='big'>
                    Login
                </Label>
                {authRedirect}
                {errorMessage}
               <form onSubmit={this.controlsHandler}>
                {form}
                <Button className="ui button primary" disabled={!this.state.formIsValid}>Sign in</Button>
               </form>
             </Container>
           
        </React.Fragment>
    }
};

const mapStatetoProps = state => {
    return {
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (email, password) => dispatch(actions.auth(email, password))
    }
};

export default connect(mapStatetoProps, mapDispatchToProps)(Login);
